import type { Partner } from '@easyguide/types'
import { useForm, Form, Create } from '@pankod/refine-antd'

import { FormInputs } from './FormTemplate'

export function CreateView() {
  const { formProps, saveButtonProps } = useForm<Partner>({
    redirect: 'list',
  })

  return (
    <Create
      saveButtonProps={saveButtonProps}
      title={`Création d'un partenaire`}
    >
      <Form {...formProps} layout="vertical">
        <FormInputs />
      </Form>
    </Create>
  )
}
